<template>
  <div>
    <div class="title">
      <div style='display: flex;'>
        <div class="title-img" v-if="img1">
          <img :src="img1" alt srcset1 class="title-img-img" />
        </div>
        <div class="title-context">
          <div class="title-context2">姓名:{{form.name}}</div>
          <div class="title-context3">电话:{{form.phone}}</div>
          <div class="title-context4">地址:{{form.address}}</div>
        </div>
      </div>
    </div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick" style="margin-top:30px">
      <el-tab-pane label="基本信息" name="first">
        <div class="first-head" style="margin-top:0px">基本信息</div>
        <el-row>
          <el-col :span="12">
            <div class="info-item">姓名:{{form.name}}</div>
            <div class="info-item">身份证号:{{form.idCode}}</div>
            <div class="info-item">楼栋名称:{{form.sectionName}}</div>
            <div class="info-item">人员类别:{{form.personType==0?'特困人员(三无、五保)':form.personType==1?'低保或低保边缘':form.personType==2?'一般老人':''}}</div>
          </el-col>
          <el-col :span="12">
            <div class="info-item">出生日期:{{form.birthDay}}</div>
            <div class="info-item">门牌号:{{form.doorCode}}</div>
            <div class="info-item">救助类型:{{form.rescueType==0?'城乡最低生活保障救助':form.rescueType==1?'特困人员供养':form.rescueType==2?'临时救助':''}}</div>
          </el-col>
        </el-row>
        <div class="first-head">紧急联系人</div>
        <el-row>
          <el-col :span="12">
            <div class="info-item">姓名:{{form.urgentName}}</div>
            <div class="info-item">姓名:{{form.criticalName}}</div>
          </el-col>
          <el-col :span="12">
            <div class="info-item">联系电话:{{form.urgentPhone}}</div>
            <div class="info-item">联系电话:{{form.criticalPhone}}</div>
          </el-col>
        </el-row>
        <div class="first-head">老人健康情况</div>
        <el-row>
          <el-col :span="12">
            <div class="info-item">药物过敏:{{form.drugAllergy}}</div>
            <div class="info-item">自理情况:{{form.drugAllergy==0?'较差，完全需要别人照顾':form.drugAllergy==1?
              '一般，有些事情需要别人照顾':form.drugAllergy==2?'较好，一般不需要别人照顾':form.drugAllergy==3?'很好，还可以照顾别人':form.drugAllergy==4?'其他':''}}</div>
            <div class="info-item">备注:{{form.remarks}}</div>
          </el-col>
          <el-col :span="12">
            <div class="info-item">饮食禁忌:{{form.dietTaboo==0?'糖':form.dietTaboo==1?
              '海鲜':form.dietTaboo==2?'蛋类':form.dietTaboo==3?'豆制品':form.dietTaboo==4?'其他':''}}</div>
            <div class="info-item" v-if="form.health==0">健康情况:身体健康</div>
            <div class="info-item" v-if="form.health==1">健康情况:高血压</div>
            <div class="info-item" v-if="form.health==2">健康情况:慢性支气管炎</div>
            <div class="info-item" v-if="form.health==3">健康情况:糖尿病</div>
            <div class="info-item" v-if="form.health==4">健康情况:类风湿</div>
            <div class="info-item" v-if="form.health==5">健康情况:颈椎病</div>
            <div class="info-item" v-if="form.health==6">健康情况:高血脂</div>
            <div class="info-item" v-if="form.health==7">健康情况:恶性肿瘤</div>
            <div class="info-item" v-if="form.health==8">健康情况:重性精神病</div>
            <div class="info-item" v-if="form.health==9">健康情况:结核病</div>
            <div class="info-item" v-if="form.health==10">健康情况:肝炎</div>
            <div class="info-item" v-if="form.health==11">健康情况:哮喘</div>
            <div class="info-item" v-if="form.health==12">健康情况:关节炎</div>
            <div class="info-item" v-if="form.health==13">健康情况:老年智力障碍</div>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="健康指数" name="second">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column type="index" width="50" label="序号" header-align="center" align="center"></el-table-column>
          <el-table-column
                  v-for="(item,index) in tableColumn"
                  :key="index"
                  :prop="item.prop"
                  :label="item.label"
                  header-align="center"
          >
            <template slot-scope="scope">
              <div

                      :style="{'text-align':item.align?item.align:'center'}"
              >{{scope.row[item.prop]}}</div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="10"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
          ></el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="用药记录" name="third">
        <el-table :data="tableData1" border style="width: 100%">
          <el-table-column type="index" width="50" label="序号" header-align="center" align="center"></el-table-column>
          <el-table-column
                  v-for="(item,index) in tableColumn1"
                  :key="index"
                  :prop="item.prop"
                  :label="item.label"
                  header-align="center"
          >
            <template slot-scope="scope">
              <div

                      :style="{'text-align':item.align?item.align:'center'}"
              >{{scope.row[item.prop]}}</div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
                  @size-change="handleSizeChange1"
                  @current-change="handleCurrentChange1"
                  :current-page="currentPage1"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="10"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total1"
          ></el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="就诊记录" name="fourth">
        <el-table :data="tableData2" border style="width: 100%">
          <el-table-column type="index" width="50" label="序号" header-align="center" align="center"></el-table-column>
          <el-table-column
                  v-for="(item,index) in tableColumn2"
                  :key="index"
                  :prop="item.prop"
                  :label="item.label"
                  header-align="center"
          >
            <template slot-scope="scope">
              <div

                      :style="{'text-align':item.align?item.align:'center'}"
              >{{scope.row[item.prop]}}</div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
                  @size-change="handleSizeChange2"
                  @current-change="handleCurrentChange2"
                  :current-page="currentPage2"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="10"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total2"
          ></el-pagination>
        </div>

      </el-tab-pane>
      <el-tab-pane label="体检记录" name="fifth">
        <el-table :data="tableData3" border style="width: 100%">
          <el-table-column type="index" width="50" label="序号" header-align="center" align="center"></el-table-column>
          <el-table-column
                  v-for="(item,index) in tableColumn3"
                  :key="index"
                  :prop="item.prop"
                  :label="item.label"
                  header-align="center"
          >
            <template slot-scope="scope">
              <div

                      :style="{'text-align':item.align?item.align:'center'}"
              >{{scope.row[item.prop]}}</div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
                  @size-change="handleSizeChange3"
                  @current-change="handleCurrentChange3"
                  :current-page="currentPage3"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="10"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total3"
          ></el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="帮扶记录" name="sixth">
        <el-table :data="tableData4" border style="width: 100%">
          <el-table-column type="index" width="50" label="序号" header-align="center" align="center"></el-table-column>
          <el-table-column
                  v-for="(item,index) in tableColumn4"
                  :key="index"
                  :prop="item.prop"
                  :label="item.label"
                  header-align="center"
          >
            <template slot-scope="scope">
              <div

                      :style="{'text-align':item.align?item.align:'center'}"
              >{{scope.row[item.prop]}}</div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="10"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total4"
          ></el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import img1 from "@/assets/images/map/1.jpg";
import {
  oldManFileCheck,
  oldManHealthList,
  oldManHelpRecondList,
  oldManPharmacyList,
  oldManPhysicalList,
  oldManSaveRecondList
} from "../api";
export default {
  components: {},
  props:['row'],
  data() {
    return {
      img1,
      activeName: "first",
      form: {

      },
      tableData: [],
      total: 0, //总数据
      pageNo: 1,
      pageSize: 10,
      currentPage: 1, //默认展示第一页
      tableColumn: [
        {
          prop: "bloodSugar",
          label: "血糖（mmol/L)"
        },
        {
          prop: "shrink",
          label: "收缩压(mmHg)"
        },
        {
          prop: "expand",
          label: "扩张压(mmHg)"
        },
        {
          prop: "blood",
          label: "血氧饱和度"
        },
        {
          prop: "heartRate",
          label: "心率(次/分钟)"
        },
        {
          prop: "releaseTime",
          label: "采集类型"
        },
        {
          prop: "createDate",
          label: "采集时间"
        },

      ],

      tableData1: [],
      total1: 0, //总数据
      pageNo1: 1,
      pageSize1: 10,
      currentPage1: 1, //默认展示第一页
      tableColumn1: [
        {
          prop: "drugName",
          label: "药品名称",
        },
        {
          prop: "startTime",
          label: "服药开始日期",
        },
        {
          prop: "endTime",
          label: "服药结束日期",
        },
        {
          prop: "uses",
          label: "使用方法",
        },
        {
          prop: "drugAmount",
          label: "用药剂量",
        },
        {
          type: "take",
          prop: "take",
          label: "服用疗程",
        },
        {
          prop: "effect",
          label: "作用",
        },
        {
          label: "操作",
          type: "button",
        },
      ],

      tableData2: [],
      total2: 0, //总数据
      pageNo2: 1,
      pageSize2: 10,
      currentPage2: 1, //默认展示第一页
      tableColumn2: [
        {
          prop: "hospital",
          label: "就诊医院"
        },
        {
          prop: "treatmentTime",
          label: "就诊日期"
        },
        {
          prop: "department",
          label: "就诊科室"
        },
        {
          prop: "account",
          label: "就诊原因"
        },
        {
          prop: "result",
          label: "诊断结果"
        },
        {
          prop: "returnTime",
          label: "复诊日期"
        },
        {
          label: "操作",
          type: "button"
        }
      ],

      tableData3: [],
      total3: 0, //总数据
      pageNo3: 1,
      pageSize3: 10,
      currentPage3: 1, //默认展示第一页
      tableColumn3: [
        {
          prop: "hospital",
          label: "体检医院",
        },
        {
          prop: "testTime",
          label: "体检日期",
        },
        {
          prop: "result",
          label: "体检结果",
        },
        {
          prop: "nextTime",
          label: "下次日期",
        },

      ],

      tableData4: [],
      total4: 0, //总数据
      pageNo4: 1,
      pageSize4: 10,
      currentPage4: 1, //默认展示第一页
      tableColumn4: [
        {
          prop: "servicePerson",
          label: "服务人员"
        },
        {
          prop: "serviceTime",
          label: "服务时间"
        },
        // {
        //   type:'serviceType',
        //   prop: "serviceType",
        //   label: "服务类型"
        // },
        {
          prop: "serviceAddress",
          label: "服务地点"
        },
        {
          prop: "serviceItems",
          label: "服务项目"
        },
        {
          prop: "duration",
          label: "服务时长(小时)"
        },

      ],
    };
  },
  methods: {
    //每页请求${val}条数据
    handleSizeChange(val) {
      this.pageSize = val;
      this.getOldManHealthListAPI();
      this.$message({
        message: `每页请求${val}条数据成功`,
        type: "success"
      });
    },
    //请求第${val}页数据
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getOldManHealthListAPI();
      this.$message({
        message: `请求第${val}页数据成功`,
        type: "success"
      });
    },


    //每页请求${val}条数据
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.oldManPharmacyListAPI();
      this.$message({
        message: `每页请求${val}条数据成功`,
        type: "success",
      });
    },
    //请求第${val}页数据
    handleCurrentChange1(val) {
      this.pageNo1 = val;
      this.oldManPharmacyListAPI();
      this.$message({
        message: `请求第${val}页数据成功`,
        type: "success",
      });
    },


    //每页请求${val}条数据
    handleSizeChange2(val) {
      this.pageSize2 = val;
      this.SaveRecondListAPI();
      this.$message({
        message: `每页请求${val}条数据成功`,
        type: "success",
      });
    },
    //请求第${val}页数据
    handleCurrentChange2(val) {
      this.pageNo2 = val;
      this.SaveRecondListAPI();
      this.$message({
        message: `请求第${val}页数据成功`,
        type: "success",
      });
    },

    //每页请求${val}条数据
    handleSizeChange3(val) {
      this.pageSize3 = val;
      this.oldManPhysicalListAPI();
      this.$message({
        message: `每页请求${val}条数据成功`,
        type: "success",
      });
    },
    //请求第${val}页数据
    handleCurrentChange3(val) {
      this.pageNo3 = val;
      this.oldManPhysicalListAPI();
      this.$message({
        message: `请求第${val}页数据成功`,
        type: "success",
      });
    },
    //拿到列表
    getOldManHealthListAPI(e) {
      let params = Object.assign({}, e, {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        oldPeopleId:this.row.id
      });
      oldManHealthList(params).then(res => {
        this.tableData = res.content.list;
        this.total = res.content.count;
      });
    },
    //拿到健康列表
    oldManPharmacyListAPI(e) {
      let params = Object.assign({}, e, {
        pageNo: this.pageNo1,
        pageSize: this.pageSize1,
        oldPeopleId: this.row.id,
      });
      oldManPharmacyList(params).then((res) => {
        this.tableData1 = res.content.list;
        this.total1 = res.content.count;
      });
    },
    //拿到就诊列表
    SaveRecondListAPI(e) {
      let params = Object.assign({}, e, {
        pageNo: this.pageNo2,
        pageSize: this.pageSize2,
        oldPeopleId:this.row.id
      });
      oldManSaveRecondList(params).then(res => {
        this.tableData2 = res.content.list;
        this.total2 = res.content.count;
      });
    },

    //每页请求${val}条数据
    handleSizeChange4(val) {
      this.pageSize4 = val;
      this.oldManHelpRecondListAPI();
      this.$message({
        message: `每页请求${val}条数据成功`,
        type: "success"
      });
    },
    //请求第${val}页数据
    handleCurrentChange4(val) {
      this.pageNo4 = val;
      this.oldManHelpRecondListAPI();
      this.$message({
        message: `请求第${val}页数据成功`,
        type: "success"
      });
    },
    //拿到体检列表
    oldManPhysicalListAPI(e) {
      let params = Object.assign({}, e, {
        pageNo: this.pageNo3,
        pageSize: this.pageSize3,
        oldPeopleId: this.row.id,
      });
      oldManPhysicalList(params).then((res) => {
        this.tableData3 = res.content.list;
        this.total3 = res.content.count;
      });
    },
    //拿到列表
    oldManHelpRecondListAPI(e) {
      let params = Object.assign({}, e, {
        pageNo: this.pageNo4,
        pageSize: this.pageSize4,
        oldPeopleId: this.row.id,
      });
      oldManHelpRecondList(params).then(res => {
        this.tableData4 = res.content.list;
        this.total4 = res.content.count;
      });
    },
    handleClick(tab, event) {
      console.log(tab, event);
      console.log(this.activeName);
      if (this.activeName == "second") {
        this.getOldManHealthListAPI()
      } else if (this.activeName == "third") {
        this.oldManPharmacyListAPI()

      } else if (this.activeName == "fourth") {
        this.SaveRecondListAPI()

      }else if (this.activeName == "fifth") {
        this.oldManPhysicalListAPI()
      }else if (this.activeName == "sixth") {
        this.oldManHelpRecondListAPI()
      }
    },
    //拿到基本信息
    provideManageAPI(e) {
      let params = Object.assign({}, e, {
        pageNo: 1,
        pageSize: 10000,
        id:this.row.id
      });
      oldManFileCheck(params).then(res => {
        console.log('res',res.content)
        this.form = res.content;
        if (this.form.photo) {
          let imgItem = res.content.photo.split(";");
          imgItem.pop()
          this.img1 = imgItem[0]
        }
      });
    },
  },
  mounted() {
    this.provideManageAPI()
  },
};
</script>

<style scoped>
#myChart {
  width: 100%;
  height: 400px;
}
#myChart1 {
  width: 100%;
  height: 400px;
}
#chart {
  width: 100%;
  height: 400px;
}
#chart1 {
  width: 100%;
  height: 400px;
}
.title {
  display: flex;
  justify-content: space-between;
}
.title-img-img {
  width: 100%;
  height: 100%;
}
.title-img {
  width: 150px;
  height: 170px;
}
.title-context {
  height: 170px;
  padding-left: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.title-context1 {
  font-size: 26px;
}
.title-context2,
.title-context3,
.title-context4 {
  font-size: 16px;
}
.top1-circle-right-item-circle {
  width: 5px;
  height: 5px;
  display: inline-block;
}
.third-center {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.first-head {
  background-color: rgb(242, 242, 242);
  padding: 10px 20px;
  font-size: 16px;
  font-weight: 700;
  margin-top: 15px;
}
.info-item {
  line-height: 40px;
  font-size: 15px;
  padding-left: 20px;
}
.title-head {
  width: 300px;
  background-color: rgb(242, 242, 242);

}
.title-head2 {
  background-color: rgb(25, 158, 216);
  height: 40px;
  text-align: center;
  line-height: 40px;
  color: #fff;
}
.title-head3 {
  line-height: 40px;
  font-size: 15px;
  padding-left: 30px;
}
</style>
